export default function IcpLink() {
  return (
    <a
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: 'inherit' }}
      className="text-sm hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4"
    >
      浙ICP备2026007067号-4
    </a>
  );
}
